import React from "react";
import GoalItem from "./GoalItem.jsx";

class GoalsList extends React.Component {
  render() {
    const { goals, onEdit, onDelete, onComplete } = this.props;

    if (!goals || goals.length === 0) {
      return <p className="text-muted mb-3">No goals added yet.</p>;
    }
    return (
      <ul className="mb-3">
        {goals.map((goal) => (
          <GoalItem key={goal.id} goal={goal} onEdit={onEdit} onDelete={onDelete} onComplete={onComplete} />
        ))}
      </ul>
    );
  }
}

export default GoalsList;
